"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_default
});
const _isFn = /*#__PURE__*/ _interopRequireDefault(require("./isFn"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper to help share reference
 *
 * @remarks
 * [Docs](https://www.davedrinks.coffee/how-do-i-use-two-react-refs/)
 *
 * @returns method - function to execute all ForwaredRef
 *
 * @example
 * ```tsx
 *
 * const ForwaredComponent = forwardRef<HTMLDivElement, ForwaredComponentProps>((props, ref) => {
 *   const localRef = useRef<HTMLDivElement>(null);
 *
 *   return <div ref={mergeRefs(ref, localRef)}/>
 * })
 *
 * ```
 */ const mergeRefs = function() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    const filteredRefs = refs.filter(Boolean);
    return (inst)=>filteredRefs.forEach((ref)=>(0, _isFn.default)(ref) ? ref(inst) : ref.current = inst);
};
const _default = mergeRefs;
